import useMediaQuery from '@mui/material/useMediaQuery';
import { Theme } from '@mui/material/styles';
import { Breakpoint } from '@mui/system'

export default function useMatchedBreakpointValues<T extends Object>(valuesPerBreakpoint: {[size in Breakpoint]?: T}, theme: Theme): T | {} {
  const matchedMediaQuery = (Object.keys(valuesPerBreakpoint) as Array<Breakpoint>).filter((breakpoint: Breakpoint) => {
    return useMediaQuery(theme.breakpoints.up(breakpoint))
  })
  return matchedMediaQuery.length > 0 ? valuesPerBreakpoint[matchedMediaQuery[0]] : {}
}
